import { useTranslation } from "react-i18next";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackSchnellCheckClick } from "@/utils/tracking";

const APP_URL = "https://app.foresthub.app";

export const Hero = () => {
  const { t } = useTranslation();

  // Primärer CTA: Zur Erklärung scrollen
  const handleExplainClick = () => {
    const element = document.getElementById('entry-steps');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Sekundärer CTA: Fall beschreiben → app.foresthub.app
  const handleAppCtaClick = () => {
    trackSchnellCheckClick();
  };

  return (
    <section 
      id="start" 
      className="relative bg-[#1B4D3E] py-16 md:py-24"
      data-testid="hero-section"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        {/* Eyebrow */}
        <p 
          className="text-sm text-white/60 mb-4 tracking-wide"
          data-testid="hero-eyebrow"
        >
          {t('hero.eyebrow')}
        </p>

        {/* H1 */}
        <h1 
          className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight mb-5"
          style={{ fontFamily: 'Outfit, sans-serif' }}
          data-testid="hero-headline"
        >
          {t('hero.headline')}
        </h1>

        {/* Subline */}
        <p 
          className="text-base text-white/80 max-w-2xl mx-auto mb-5 leading-relaxed"
          data-testid="hero-subheadline"
        >
          {t('hero.subheadline')}
        </p>

        {/* Trustline */}
        <p 
          className="text-sm text-white/50 mb-8"
          data-testid="hero-trustline"
        >
          {t('hero.trustline')}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {/* Primärer CTA: Erst den Ablauf ansehen */}
          <Button 
            onClick={handleExplainClick}
            className="bg-white text-[#1B4D3E] hover:bg-stone-100 h-11 px-6 rounded-lg text-sm font-medium"
            data-testid="hero-primary-cta"
          >
            {t('hero.primaryCta')}
            <ArrowDown className="ml-2 w-4 h-4" />
          </Button>
          
          {/* Sekundärer CTA: Fall kostenlos beschreiben */}
          <a 
            href={APP_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={handleAppCtaClick}
          >
            <Button 
              variant="outline" 
              className="border border-white/30 text-white bg-transparent hover:bg-white hover:text-[#1B4D3E] h-11 px-6 rounded-lg text-sm font-medium transition-all duration-300"
              data-testid="hero-secondary-cta"
            >
              {t('hero.secondaryCta')}
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
